import React from 'react';
import Expenses from '../admin/Expenses';

const CounterExpenses = () => {
  return <Expenses />;
};

export default CounterExpenses;
